module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Character List")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "flourish",
      "src": "images/flourish.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p15"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Rapella Ripple -")]), _vm._v(" Just because this feisty senior citizen is well beyond her spring-chicken days, doesn't mean she's not an audacious ball of fire. Given her intrepid spirit and meddlesome tendencies, it's no wonder she lands herself in one awkward situation after another. Despite the occasional humiliation, and frequent wrong turns, nothing short of a massive coronary will stop her. But will that deeply ingrained tenaciousness pay off?")])]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Clyde \"Rip\" Ripple -")]), _vm._v(" The other, more pragmatic half of this full-time RVing couple. As a career lawman, he wants to catch the killer as much as his wife, but goes about it in a more sensible, level-headed way. Will he get the opportunity to watch his fellow sheriff eat crow after she blows off his offer to assist in the investigation?")])]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Cora Beaufont -")]), _vm._v(" The Ripples' niece who resides in Buffalo, Wyoming. She's holding down the fort while her husband is away on business. Cora's the person responsible for talking her aunt into buying a motion-sensor camera and later pays for Rapella's entry in a wildlife photography contest. Cora could not have imagined how that challenge would turn out. But will her thirty-dollar investment pay off?")])]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("William \"Slick Willie\" Beaufont -")]), _vm._v(" Cora's fourteen-year old son whose talents include playing baseball, auto mechanics, and conjuring up clever schemes. There's a good reason his Uncle Rip refers to him as Slick Willie. Will his idea to help track down a poacher pan out?")])]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Beata \"Bea\" Whetstone ")]), _vm._v("- Co-owner of the Rest 'n Peace RV Park, a campground surrounded by the Bighorn National Forest. Bea's not the most pleasant person to be around, so when she goes missing it's anyone's guess who, or what, is behind her disappearance. Did someone despise her enough to want her dead?")])]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Boonie Whetstone -")]), _vm._v(" Beata's husband and business partner. There's reason to believe he might have had a hand in his wife's disappearance. But could it be because he has another woman waiting in the wings to replace her?")])]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Richard \"Ranger Rick\" Myer -")]), _vm._v(" A park ranger who befriends the Ripples. Rip and Rapella have to put their fondness for the man aside to determine if he had a strong enough motive to kill Beata Whetstone. Was he friend or foe of the victim?")])]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Janelle Tyson-Simms -")]), _vm._v(" The gold-digging woman Boonie was seeing behind his wife's back before Bea's grisly death. Did she want to snag Boonie badly enough to eliminate her competition?")])]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("John and Barb Harris -")]), _vm._v(" Animal activists who are staying at the Whetstones' campground. They're upset when Beata kills a bear on the park's property. But were they ticked off enough to kill her?")])]), _vm._v(" "), _c('p', {
    staticClass: "p17"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Desireé Myer -")]), _c('span', {
    staticClass: "s3"
  }, [_vm._v(" Ranger Rick's ex-wife, who's also the victim's sister. The shop she owns in Buffalo is the last sort of store Rapella would want to patronize. But Rapella is so determine")]), _vm._v("d to track down Bea's killer that she'd walk through fire in search of the truth. Desireé and Bea's mother has been diagnosed with terminal esophageal cancer, and the sisters are both in line to inherit a fair amount of dough. Was there a compelling enough reason, whether personal or monetary, for Desireé to want her sister out of the picture, as well as out of their mother's will?")])]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Leo and Charly Brown")]), _vm._v(" - The owners of the Sweet Sixteen RV Park, located two miles west of the Rest 'n Peace RV Park. Before Bea's disappearance, the two determined rivals had engaged in an all-out tug of war for customers. Were the Browns determined to get in the last punch?")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Jaclyn Wright -")]), _vm._v(" The sheriff of Johnson County, Wyoming, who shows an offensive lack of respect for Rip Ripple. Rip refers to the stern, no-nonsense woman as \"battleaxe\", and her sense of superiority only strengthens his resolve to solve the case. Which sheriff will come out on top in this rivalry?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-134dffc8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section6.vue
// module id = 75
// module chunks = 0